// extracted by mini-css-extract-plugin
module.exports = {"indented":"Signup_indented__2VWRX","fontSmallerIndented":"Signup_fontSmallerIndented__1ici_","credentialsAbroad":"Signup_credentialsAbroad__3-hFI"};